
<template>
	<div v-if="error" class="alert-icon">
		<i class="material-icons md-18">error</i>
		<div v-if="error" class="invalid-feedback">
			{{error}}
		</div>
	</div>
</template>

<script>
export default {
	props:{
		error: String,
	}
}
</script>

<style scoped>
.alert-icon{position:absolute;bottom:5px;right:5px;color:#CC1717;cursor:help;z-index:2;}
.invalid-feedback{position:absolute;top:20px;right:0;left:auto;background-color:#CC1717;color:#FFF;display:none;
	padding:6px 8px;border-radius:3px;min-width:125px;line-height:1.2;}
.alert-icon:hover .invalid-feedback{display:block;}
</style>


// WEBPACK FOOTER //
// src/components/form/input-alert.vue